/**
 * Auth0 Configuration
 *
 * Environment variables required:
 * - VITE_AUTH0_DOMAIN: Your Auth0 domain (e.g., your-tenant.us.auth0.com)
 * - VITE_AUTH0_CLIENT_ID: Your Auth0 application client ID
 * - VITE_AUTH0_AUDIENCE: Your Auth0 API audience (optional)
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: 'openid profile email offline_access',
    ...(import.meta.env.VITE_AUTH0_AUDIENCE && {
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    }),
  },
};
